import { Box, Button, Flex, Heading, HStack, Image, Text, VStack } from "@chakra-ui/react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import CryptoJS from "crypto-js";

// Icons
import { IconEjecutivo, IconInfo } from "../../Assets/GENERALES/Icons";
import { IconNewLine, IconPorta } from "../../Assets/MOVIL/Icons";
import { BsChevronLeft } from "react-icons/bs";

// Componentes
import SlideModal from "../../Components/Slide/SlideModal";
import enviroments from "../../Services/enviroments";
import Footer from "../../Components/Footer/Footer";

// Imagenes
import Logo from '../../Assets/Logos/entel-logo2.webp';

const SelectContratacionMovil = () => {

    const [precioNormalSolicitado, setPrecioNormalSolicitado] = useState('');
    const [precioSolicitado, setPrecioSolicitada] = useState('');
    const [openSlideModal, setOpenSlideModal] = useState(false);
    const [typeLine, setTypeLine] = useState('portabilidad');
    const [planSolicitado, setPlanSolicitada] = useState('');
    const [descuentoPlan, setDescuentoPlan] = useState('');
    const [id, setId] = useState('');

    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const idPlan = searchParams.get("planId");
    const oda = searchParams.get("oda");

    const arrayPlanesMovil = [
        {
            id: 1,
            planid: 'PO_POS_OO_17176',
            recomendado: 0,
            tipoPlan: 'Plan',
            plan: '150 Gigas',
            dcto: '0%',
            timeOffer: '6 meses',
            precio: '12.990',
            luego: '$12.990',
        },
        {
            id: 2,
            planid: 'PO_POS_OO_17196',
            recomendado: 1,
            tipoPlan: 'Plan <b>Te Sumo</b>',
            plan: '450 Gigas',
            dcto: '50%',
            timeOffer: '6 meses',
            precio: '8.495',
            luego: '$16.990',
        },
        {
            id: 3,
            planid: 'PO_POS_OO_17180',
            recomendado: 0,
            tipoPlan: 'Plan <b>Te Sumo</b>',
            plan: 'Libre',
            dcto: '50%',
            timeOffer: '6 meses',
            precio: '11.995',
            luego: '$23.990',
        },
        {
            id: 4,
            planid: 'PO_POS_OO_17456',
            recomendado: 0,
            tipoPlan: 'Plan <b>Te Sumo</b>',
            plan: 'Libre con Roaming',
            dcto: '50%',
            timeOffer: '6 meses',
            precio: '14.995',
            luego: '$29.990',
        },
        {
            id: 5,
            planid: 'PO_POS_OO_14116',
            recomendado: 0,
            tipoPlan: 'Plan <b>Te Sumo</b>',
            plan: 'Libre con Roaming Pro',
            dcto: '50%',
            timeOffer: '6 meses',
            precio: '19.995',
            luego: '$39.990',
        },
    ];

    const handleClickToButton = (plan, precio, luego, label) => {
        window.dataLayer.push({
            event: 'GARDevent',
            eventCategory: 'planes - ¿como quieres contratar?',
            eventAction: 'click to action',
            eventLabel: label,
            origen: 'entel',
            mercado: 'pe',
            segmento: 'po',
            product_name: plan.toLowerCase(),
            product_quantity: '1',
            product_price: precio.replace(/[$.]/g, ''),
            product_subprice: luego.replace(/[$.]/g, ''),
            form_step_name: `paso 0 - estas solicitando plan ${plan}`,
            journey_name : `plan ${typeLine}`,
            journey_type: 'solicitud',
            page_owner: 'movil',
            page_category: 'landing-comercial'
        })
    };

    useEffect(() => {
        arrayPlanesMovil.map((planes) => {
            let numeroPlan = planes.id
            if(numeroPlan.toString() === idPlan){
                window.dataLayer.push({
                    event: 'GARDNIevent',
                    eventCategory: 'planes - ¿como quieres contratar?',
                    eventAction: 'info',
                    eventLabel: 'carga',
                    origen: 'entel',
                    mercado: 'pe',
                    segmento: 'po',
                    product_name: planes.plan,
                    product_quantity: '1',
                    product_price: planes.precio.replace(/[$.]/g, ''),
                    product_subprice: planes.luego.replace(/[$.]/g, ''),
                    form_step_name: `paso 0 - estas solicitando plan ${planes.plan}`,
                    journey_name : 'plan',
                    journey_type: 'solicitud',
                    page_owner: 'movil',
                    page_category: 'landing-comercial'
                });
            }
        });
    }, []);

    const password = 'XAB10CD65NB88WR32HA09TY42PQ27SF8';
    const iv = CryptoJS.enc.Hex.parse('00000000000000000000000000000000');

    const encryptAES = (text) => {
        try {
            const key = CryptoJS.enc.Utf8.parse(password);

            const encrypted = CryptoJS.AES.encrypt(
                text,
                key,
                {
                    iv: iv,
                    mode: CryptoJS.mode.CTR,
                    padding: CryptoJS.pad.NoPadding,
                }
            );

            return encrypted.toString();
        } catch (error) {
            console.error('Error al encriptar:', error);
            return null;
        }
    };

    const handleRedirect = ({timeOffer, luego, plan, precio, dcto, planid}, seccion) => {
        handleClickToButton(plan, precio, luego, 'contratar en linea');

        let namePlan = plan;

        if (plan.includes('Gigas')) {
            namePlan = plan.replace(' Gigas', 'GB');
        } if (plan.includes('con')) {
            namePlan = plan.replace(' con ', ' ');
        }
        const estructuraUrl = `${dcto.replace('%','')};Plan ${namePlan};${precio.replace(/[$.]/g, '')};${luego.replace(/[$.]/g, '')};${luego.replace(/[$.]/g, '')};1;${planid};${seccion};por ${timeOffer},luego ${luego.replace(/[.]/g, '')}/mes;legados;NoCliente`;
        const urlEncriptada = encryptAES(estructuraUrl);
        var form = $(`<form action="https://miportal.entel.cl/personas/planes/identificacion?oda=${oda}" method="post">` +
            `<input type="hidden" name="plan" value="${urlEncriptada}" />` +
            '</form>');
        $('body').append(form);
        form.submit();
    };

    const infoModal = (view) => {
        const plan = arrayPlanesMovil.filter((plan) => plan.id == idPlan)[0];
        handleClickToButton(plan.plan, plan.precio, plan.luego, 'quiero que me llamen');

        setPrecioNormalSolicitado(plan.luego);
        setId(`${view}Movil Form Plan ${plan.id}`);
        setPrecioSolicitada(plan.precio);
        setDescuentoPlan(plan.dcto);
        setPlanSolicitada(plan.plan);
        setOpenSlideModal(true);
    };

    const handleChangeSeccion = (seccion) => {
        arrayPlanesMovil.map((planes) => {
            let numeroPlan = planes.id
            if(numeroPlan.toString() === idPlan) {
                window.dataLayer.push({
                    event: 'GARDevent',
                    eventCategory: 'planes - ¿como quieres contratar?',
                    eventAction: 'interaction',
                    eventLabel: seccion.toLowerCase(),
                    origen: 'entel',
                    mercado: 'pe',
                    segmento: 'po',
                    product_name: planes.plan,
                    product_quantity: '1',
                    product_price: planes.precio.replace(/[$.]/g, ''),
                    product_subprice: planes.luego.replace(/[$.]/g, ''),
                    form_step_name: `paso 0 - estas solicitando plan ${planes.plan}`,
                    journey_name : 'plan',
                    journey_type: 'solicitud',
                    page_owner: 'movil',
                    page_category: 'landing-comercial'
                });
            }
        });
        setTypeLine(seccion);
    };

    return (
        <GoogleReCaptchaProvider
            reCaptchaKey={enviroments?.site_key}
            useEnterprise={true}
        >
            {/* Navbar */}
            <Box bg='white' h='60px' borderBottom='2px solid #F4F4F4'>
                <Flex w={['95%','95%','80%','90%','90%']} py={['3','3','1.5','1.5','1.5']} px='2' mx='auto' alignItems='center' h='100%'>
                    <Image src={Logo} h='100%' onClick={() => navigate(-1)} cursor='pointer' />
                </Flex>
            </Box>

            {/* Body */}
            <Flex h={['auto','auto','90vh','90vh','90vh']} flexDirection={['column','column','row','row','row']}>
                {/* Estas llevando */}
                <Box w={['100%','100%','40vw','40vw','40vw']} bg='white' mb='5' pt={[4,4,10,10,10]} px={[5,5,20,20,20]}>
                    <Heading className="Bold" size='md'>
                        Estas llevando:
                    </Heading>

                    <Box boxShadow='0px 0px 1.5px 0px gray' borderRadius='8px' mt='5'>
                        {
                            arrayPlanesMovil.map((plan) => plan.id == idPlan &&
                                <Box key={plan?.id}>
                                    {
                                        plan?.recomendado 
                                        ? <Box textAlign='center' bg='#002EFF' borderTopRadius='8px'>
                                            <Text className='Subtitle' color='white' fontSize='lg'><b>Recomendado</b></Text>
                                        </Box>
                                        : ''
                                    }
                                    <Box key={plan.id}  p='3'>
                                        <Text className="General" dangerouslySetInnerHTML={{__html:plan.tipoPlan}}></Text>
                                        <Text className="SemiBold" fontSize='lg'>{plan.plan}</Text>

                                        {
                                            plan.dcto !== '0%'
                                            && <HStack mt='3' spacing='0' >
                                                <Text border='1px solid #42E8B4' color='black' bg='#42E8B4' px='2' className="Title" h='auto' lineHeight='1.1' borderLeftRadius='5px'>
                                                    {plan.dcto} dcto
                                                </Text>
                                                <Text border='1px solid #42E8B4' px='2' className="Title" lineHeight='1.1' borderRightRadius='5px'>
                                                    Oferta Online
                                                </Text>
                                            </HStack>
                                        }

                                        <HStack my='3' spacing='1' alignItems='end'>
                                            <Heading color="#002EFF" className="Subtitle" size='xl' lineHeight='1' >$</Heading>
                                            <Heading color="#002EFF" className="Subtitle" size='xl' lineHeight='0.9'>{plan.precio}</Heading>
                                            <Heading color="#002EFF" className="Subtitle" size='md' lineHeight='1' >/mes</Heading>
                                        </HStack>
                                        <Text className="General">Por 6 meses, luego <b>{plan.luego}</b></Text>
                                    </Box>
                                </Box>
                            )
                        }
                    </Box>
                </Box>

                <Box w={['100%','100%','60vw','60vw','60vw']} bg='#F7F7F7' py='10'>
                    {/* ¿Como quieres contratar? */}
                    <Box w={['100%','100%','70%','70%','70%']} mx='auto' px={[5,5,0,0,0]}>
                        <Heading className="Bold" size='md'>
                            ¿Qué tipo de líneas quieres?
                        </Heading>

                        {/* Secciones */}
                        <Flex mt='8' bg='white'>
                            <Button 
                                w='100%'
                                variant='link'
                                pt={3} borderRadius='0px'
                                onClick={() => handleChangeSeccion('portabilidad')}
                                flexDirection='column'
                                _hover={{}}
                                justifyContent='center'
                                alignItems='center'
                                borderBottom={typeLine === 'portabilidad' ? '2px solid #002FFD': '1px solid #A4A4A6'}
                            >
                                <IconPorta size='24px' color={typeLine === 'portabilidad' ? '#002FFD' : 'black'} />
                                <Text color={typeLine === 'portabilidad' ? '#002FFD' : 'black'} my='2' size='lg' className='General'>
                                    Portabilidad
                                </Text>
                            </Button>
                            <Button 
                                w='100%'
                                variant='link'
                                pt={3} borderRadius='0px'
                                onClick={() => handleChangeSeccion('linea nueva')}
                                flexDirection='column'
                                _hover={{}}
                                justifyContent='center'
                                alignItems='center'
                                borderBottom={typeLine === 'linea nueva' ? '2px solid #002FFD': '1px solid #A4A4A6'}
                            >
                                <IconNewLine size='24px' color={typeLine === 'linea nueva' ? '#002FFD' : 'black'} />
                                <Text color={typeLine === 'linea nueva' ? '#002FFD' : 'black'} my='2' size='lg' className='General'>
                                    Línea nueva
                                </Text>
                            </Button>
                        </Flex>

                        {
                            typeLine === 'portabilidad'
                                ? <>
                                    <Flex bg='#F3F5FF' my='7' alignItems='center' px='3' py='2'>
                                        <IconInfo size='25px' />
                                        <Text className="General" ml='4'>Recuerda que debes ser el titular del número a portar.</Text>
                                    </Flex>

                                    <Text size='lg' className="General" mb='7'>¿Cómo quieres contratar?</Text>

                                    <VStack spacing='4'>
                                        {/* <Flex onClick={() => handleRedirect(arrayPlanesMovil.filter((plan) => plan.id == idPlan)[0], 'porta')} id={`Movil_Contratar_Online_${arrayPlanesMovil.filter((plan) => plan.id == idPlan)[0].id}`} border='2px solid #002FFD' position='relative' w='100%' cursor='pointer' alignItems='center' borderRadius='10px' p='3' _hover={{bg:'#E2E8F0'}}>
                                            <Flex bg='#A0F3D9' px='2' borderRadius='4px' fontSize='sm' className="Subtitle" position='absolute' top='-3' right='5'>
                                                Más rápido y fácil
                                            </Flex>
                                            <IconCoete size='35px' color='#002FFD' />
                                            <Text ml='3' className="Title" color='#002FFD' >Contratar en línea</Text>
                                            <Spacer />
                                            <BsChevronRight size='25px' color='#002FFD' />
                                        </Flex> */}

                                        <Flex boxShadow='0px 0px 2px 0px gray' w='100%' onClick={() => infoModal('')} cursor='pointer' alignItems='center' borderRadius='10px' p='3' _hover={{bg:'#E2E8F0'}}>
                                            <IconEjecutivo size='35px' color='#002FFD' />
                                            <Text ml='3' className="Title">Quiero que me llamen</Text>
                                        </Flex>
                                    </VStack>

                                    <Flex bg='#F3F5FF' mt='20' alignItems='center' px='3' py='2'>
                                        <IconInfo size='25px' />
                                        <Text className="General" ml='4'>
                                            Horario de atención: lunes a sábado de 09:00 a 20:00 hrs.
                                        </Text>
                                    </Flex>

                                    <Flex justifyContent='center' mt='5'>
                                        <Button leftIcon={<BsChevronLeft size='20px' />} onClick={() => navigate(-1)} variant='link' color='#002FFD' textDecoration='underline'>
                                            Volver al paso anterior
                                        </Button>
                                    </Flex>
                                </>
                                : <>
                                    <Text size='lg' className="General" mt='7'>¿Cómo quieres contratar?</Text>

                                    <VStack spacing='4' mt='8'>
                                        {/* <Flex onClick={() => handleRedirect(arrayPlanesMovil.filter((plan) => plan.id == idPlan)[0], 'nuevo')} id={`Linea_Nueva_Contratar_Online_${arrayPlanesMovil.filter((plan) => plan.id == idPlan)[0].id}`} border='2px solid #002FFD' position='relative' w='100%' cursor='pointer' alignItems='center' borderRadius='10px' p='3' _hover={{bg:'#E2E8F0'}}>
                                            <Flex bg='#A0F3D9' px='2' borderRadius='4px' fontSize='sm' className="Subtitle" position='absolute' top='-3' right='5'>
                                                Más rápido y fácil
                                            </Flex>
                                            <IconCoete size='35px' color='#002FFD' />
                                            <Text ml='3' className="Title" color='#002FFD' >Contratar en línea</Text>
                                            <Spacer />
                                            <BsChevronRight size='25px' color='#002FFD' />
                                        </Flex> */}
                                        <Flex border='1px solid #E9E9E9' w='100%' onClick={() => infoModal('Linea_Nueva_')} cursor='pointer' alignItems='center' borderRadius='10px' p='3' boxShadow='0px 0px 2px 0px gray' _hover={{bg:'#E2E8F0'}}>
                                            <IconEjecutivo size='35px' color='#002FFD' />
                                            <Text ml='3' className="Title">
                                                Quiero que me llamen
                                            </Text>
                                        </Flex>
                                    </VStack>

                                    <Flex bg='#F3F5FF' mt='5' alignItems='center' px='3' py='2'>
                                        <IconInfo size='25px' />
                                        <Text className="General" ml='4'>
                                            Horario de atención: lunes a sábado de 09:00 a 20:00 hrs.
                                        </Text>
                                    </Flex>

                                    <Flex justifyContent='center' mt='5 '>
                                        <Button leftIcon={<BsChevronLeft size='20px' />} onClick={() => navigate(-1)} variant='link' color='#002FFD' textDecoration='underline'>
                                            Volver al paso anterior
                                        </Button>
                                    </Flex>
                                </>
                        }
                    </Box>
                </Box>
            </Flex>

            {/* Footer */}
            <Footer />

            {/* Abrir modal */}
            {
                openSlideModal && 
                <Box
                    position="fixed"
                    top="0"
                    left="0"
                    width="100%"
                    height="100%"
                    backgroundColor="rgba(53, 52, 68, 0.7)"
                    zIndex="9"
                >
                    <SlideModal 
                        setOpenSlideModal={setOpenSlideModal} 
                        priceTyc={precioNormalSolicitado}
                        openSlideModal={openSlideModal} 
                        linkRedirect=''
                        descuento={descuentoPlan}
                        price={precioSolicitado}
                        valuePhoneInitial={''}
                        submitInitial={false}
                        plan={planSolicitado}
                        seccionSelected={typeLine}
                        intermedia={true}
                        seccion={'Movil'}
                        view='plan'
                        id={id}
                    />
                </Box>
            }
        </GoogleReCaptchaProvider>
    )
}

export default SelectContratacionMovil;